import React from 'react';
import SignalStoryCard from './SignalStoryCard';

/** The same card at 1080×1080. */
export default function SignalFeedCard(props) {
  return <SignalStoryCard {...props} format="feed" />;
}
